module.exports = __webpack_public_path__ + "static/img/czbank.7de8331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/czbank.png
// module id = lnJI
// module chunks = 93